import { render, staticRenderFns } from "./FlowRecord.vue?vue&type=template&id=73eafb1f&scoped=true"
import script from "./FlowRecord.vue?vue&type=script&lang=js"
export * from "./FlowRecord.vue?vue&type=script&lang=js"
import style0 from "./FlowRecord.vue?vue&type=style&index=0&id=73eafb1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eafb1f",
  null
  
)

export default component.exports